// Ticket and checkout screens should stay clear of seasonal chrome.
export function isBookingOrTicketsPath(pathname = '') {
  const path = String(pathname).split('?')[0].replace(/\/+$/, '') || '/';
  if (path === '/your-visit') return true;
  return /(?:^|\/)(?:tickets|day-tickets|book-tickets|booking-journey2?|booking-selection|tour-booking|afternoon-tea-booking|exhibition-booking|print-ticket|manage-booking)(?:\/|$)/i.test(path);
}
